
function setWizzyCustomPlaceHolder() {
  // Wizzy Animated Placeholder function declare:-
  let desktop, mobile_1, mobile_2;
  if (document.documentElement.clientWidth >= 768) {
    desktop = document.querySelector(
      "#st-desktop-input"
    );
  }
  if (document.documentElement.clientWidth < 768) {
    mobile_2 =  document.querySelector("#st-mobile-input");
  }
  const phrases = [
    "Search for Shampoo",
    "Search for Bathing Bar",
    "Search for Body Lotion",
    "Search for Dandruff"
  ];
  let index = 0;
  let typingTimer;
  const typePhrase = function (placeholderText) {
    const phrase = phrases[index];
    const len = phrase.length;
    let i = 0;
    typingTimer = setInterval(function () {
      if (i === len) {
        clearInterval(typingTimer);
        setTimeout(function() {
          erasePhrase(placeholderText);
        }, 1000); // Wait for 1 second before erasing
      } else {
        const currentText = placeholderText.getAttribute("placeholder");
        placeholderText['placeholder'] = currentText + phrase.charAt(i);
        i++;
      }
    }, 100); // Change the speed of typing by changing this value
  };

  const erasePhrase = function (placeholderText) {
    const currentText = placeholderText.getAttribute("placeholder");
    const len = currentText.length;
    let i = len - 1;
    typingTimer = setInterval(function () {
      if (i === (len - phrases[index].length)-1) {
        clearInterval(typingTimer);
        index++;
        if (index === phrases.length) {
          index = 0;
        }
        setTimeout(function() {
          typePhrase(placeholderText);
        }, 1000); // Wait for 1 second before typing the next phrase
      } else {
        const newText = currentText.slice(0, i);
        placeholderText.setAttribute("placeholder", newText);
        i--;
      }
    }, 50); // Change the speed of erasing by changing this value
  };

  if(document.documentElement.clientWidth < 768) {
    if(mobile_2) {
      typePhrase(mobile_2);
    }
  }else {
    if(desktop) {
      typePhrase(desktop);
    }
  }
  
}

setWizzyCustomPlaceHolder()




function checkWizzyConfigAndUpdate(){

    if(window.wizzyConfig){
    if(window.matchMedia("(max-width: 768px)").matches){
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: "#st-mobile-input",
        type: "text",
      };
    }
    else{
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: "#st-desktop-input",
        type: "text",
      };
    }

      clearInterval(interval)
    }
    
  }

  var interval = setInterval(checkWizzyConfigAndUpdate, 10);


const wizzyLazyAssetUtils = {
    isWizzyLazyLoaded: false,
    isCollectionEnabled:true,
    wizzyStore : JSON.parse(window.localStorage.getItem('wizzy_store'))??false,
    collectionId:document.querySelector("[data-collection-id]")?.getAttribute("data-collection-id")??false,
    productId: document.querySelector("[data-product-id]")?.getAttribute("data-product-id")??false,
    pageHandle: document.querySelector("[data-page-handle]")?.getAttribute("data-page-handle")??false,
    currentEle: null,
    enableWizzyAssets(targetEle = null) {
        if ( !this.isWizzyLazyLoaded) {
            this.isWizzyLazyLoaded=true
            window.wizzyLazyAssets.load();
        }

    },
    isValidTargetEleToEnable(targetEle){
        return targetEle.getAttribute("name") == "q" &&
            targetEle.getAttribute("type") == "text";
    },
    clickCondition(targetEle){
        var self = wizzyLazyAssetUtils;
        return wizzyLazyAssetUtils.isValidTargetEleToEnable(targetEle);
    },
    keyDownCondition(targetEle){
        var self = wizzyLazyAssetUtils;
        return wizzyLazyAssetUtils.isValidTargetEleToEnable(targetEle);
    },
    handleInitClick(e) {
        var self = wizzyLazyAssetUtils;
        let targetEle = e.target;
        if (self.clickCondition(targetEle)
            &&
            !window.isWizzyLazyLoaded
        ) {
            self.currentEle = targetEle;
            self.enableWizzyAssets(targetEle);

            document.removeEventListener("click", self.handleInitClick);
        }
    },
    handleInitKeyDown(e){
        var self = wizzyLazyAssetUtils;
        let targetEle = e.target;
        if (self.keyDownCondition(targetEle)
            &&
            !window.isWizzyLazyLoaded
        ) {
            self.currentEle = targetEle;
            self.enableWizzyAssets(targetEle);
            document.removeEventListener("keydown", self.handleInitKeyDown);
        }

    },
    attachEvents() {
        var self = wizzyLazyAssetUtils;
        document.addEventListener("click", self.handleInitClick);
        document.addEventListener("keydown", self.handleInitKeyDown);

        window.addEventListener("onWizzyScriptLoaded", () => {
            window.wizzySearchInit();
        });

        window.addEventListener("onWizzyInit", () => {
            if (self.currentEle) {
                setTimeout(() => {
                    self.currentEle.click();
                }, 10);
            }

            document.removeEventListener("click", self.handleInitClick);
        });
    },
    isOnValidaProductPage(){
        let self = wizzyLazyAssetUtils;
        return self.wizzyStore
            && typeof self.wizzyStore == 'object'
            && self.wizzyStore.hasOwnProperty('CLICKED_PRODUCTS')
            && typeof self.wizzyStore['CLICKED_PRODUCTS'] == 'object'
            && self.wizzyStore['CLICKED_PRODUCTS'].hasOwnProperty(self.productId)
            ;
    },
    isOnCollectionPage(){
        let self = wizzyLazyAssetUtils;
        return self.isCollectionEnabled && self.collectionId != undefined && self.collectionId !="" && self.collectionId != null;
    },
    isNeedToAutoInitWizzy(){
        var self = wizzyLazyAssetUtils;
        return self.pageHandle == "/pages/search" || self.isOnValidaProductPage() || self.isOnCollectionPage();
    },
    init() {
        var self = wizzyLazyAssetUtils;
        this.attachEvents();
        if (!window.wizzyConfigUpdated) {
            let wizzyCategoryPageInterval = setInterval(() => {
                if (window.wizzyConfigUpdated) {
                    clearInterval(wizzyCategoryPageInterval);
                    if (self.isNeedToAutoInitWizzy())
                        self.enableWizzyAssets();

                }
            }, 10);
        } else {
            if (self.isNeedToAutoInitWizzy())
                self.enableWizzyAssets();

        }
    },
};

window.onload=(e)=>wizzyLazyAssetUtils.init();


window.onWizzyScriptLoaded = function () {
  wizzyCustomUtils.init()
}

let isOnSearchPage = false;

const wizzyCustomUtils = {

  isMobile: function(){
    return window.matchMedia("(max-width: 768px)").matches;
  },
  
  init: function(){
    this.replaceAllTemplate();
    this.allEventsRegister();
    this.attachClickEvents();
  },

  attachClickEvents: function(){
    let self = this;
    $("body").on("click", ".wizzy-filters-header", function(){
     $(".wizzy-main-content").toggleClass("wizzy-filters-opened");
      if(self.isMobile()){
        $(".wizzy-filters-bg").click();
      }
    })
  },
    

  beforeInit: function(){
    this.registerWizzyEvent("BEFORE_INIT", function(payload){
      // console.log(payload);
      payload.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: "header input",
        type: "text",
      };
    payload.filters = { configs: { keepOpenedInMobileAfterApply: true } };
      return payload;
    })
  },

  beforeAutocompleteRender: function(){
    this.registerWizzyEvent("BEFORE_AUTOCOMPLETE_RENDER", function(payload) {
      // console.log(payload,"beforeAutocompleteRender");
    })
  },

  beforeRenderResults: function(){
    let self = this;
    this.registerWizzyEvent("BEFORE_RENDER_RESULTS", function(payload){
       payload.response.payload.facets.forEach((facet)=>{

          if (facet.key == "product_Size" && facet.data.length > 0) {
            let sizes = facet.data;
            let updatedArray = self.sizeSorting(sizes);
            try{
              facet.data = updatedArray.filter((item)=>item.key !== "Default Title");
            }catch(e){
              // console.log(e)
            }
          }
       })
      
      return payload;
    })
    
  },

  productsResultsRendered: function(){
    let self = this;
    this.registerWizzyEvent("PRODUCTS_RESULTS_RENDERED", function(payload) {
      if($(".wizzy-search-results .wizzy-result-product").length === 1){
        $(".wizzy-search-wrapper").addClass("wizzy-single-product-rendered");
      }
      else{
        $(".wizzy-search-wrapper").removeClass("wizzy-single-product-rendered")
      }
      if(window.wizzyConfig.common.isOnCategoryPage){
        $(".breadcrumbs").css("display","flex");
        // alert(window.location.href)
        if(window.wizzyConfig.common.collectionHandle === "buy-3-at-1249"){
          // alert("at buy-3-at-1249")
          clickSiblings()
        }
      }
    return payload;
    })
  },

  productsCachedResultsRendered: function() {
    let self = this;
    this.registerWizzyEvent("PRODUCTS_CACHED_RESULTS_RENDERED", function(payload){
      if(window.wizzyConfig.common.collectionHandle === "buy-3-at-1249"){
          // alert("at buy-3-at-1249")
          clickSiblings()
        }
      return payload;
    })
  },

  beforeAutocompleteExecuted:function(){
    let self = this;
    this.registerWizzyEvent("BEFORE_AUTOCOMPLETE_EXECUTED", function(payload){
      // console.log(payload,"beforeAutocompleteExecuted");
      payload.swatch = [{"key": "sizes"}]
      return payload;
    })
  },

    beforeSearchExecuted:function(){
    let self = this;
    this.registerWizzyEvent("BEFORE_SEARCH_EXECUTED", function(payload){
      payload.includeOutOfStock = "true";
      $(".shopify-section.section-fullscreen.section-hero").hide();
      $(".wizzy-search-results-rendered .d-flex--bread").hide();
      // console.log(payload,"beforeSearchExecuted");
      return payload;
    })
  },

  viewRendered:function(){
    let self = this;
    this.registerWizzyEvent("VIEW_RENDERED", function(payload){
      if($(".wizzy-search-input").val() === ""){
        $(".wizzy-autocomplete-top-products-view-more").css("display","none")
      }
    return payload;
    })
  },
  
    beforeFilterExecuted:function(){
    let self = this;
    this.registerWizzyEvent("BEFORE_FILTERS_EXECUTED", function(payload){
      if(window.wizzyConfig.common.isOnCategoryPage && wizzyConfig.common.collectionHandle === 'buy-3-at-1249'){
        //comment
        // payload.filters.sort =[{"field": "sellingPrice","order": "asc"}, {"field": "relevance","order": "asc"}]
        // payload.filters.showOOSProductsInOrder = "true"
        // console.log("THIS IS FILTER SORT",payload.filters)
         payload.filters.inStock= [true]
        
      }
      else if(window.wizzyConfig.common.isOnCategoryPage){
        payload.filters.inStock= [true,false]
      }else{
        payload.filters.inStock= [true,false]
      }
       // console.log(payload.filters,"beforeFilterExecuted");
      return payload;
    })
  },

  afterProductsTransformed: function(){
      this.registerWizzyEvent("AFTER_PRODUCTS_TRANSFORMED", function(payload) {
        payload.forEach((product)=>{
          product.attributes.forEach((attribute)=>{
            if(attribute.id === "product_badge_judgeme"){
              let a = $(attribute.values[0].value[0]).attr("data-average-rating");
              let b =  $(attribute.values[0].value[0]).attr("data-number-of-reviews");
              product.avgRating = a == 0.00 ? a : parseFloat(a).toFixed(1).toString();
              product.reviewCount = b == 0 ? false : b;
            }

            if(attribute.id === "product_handle"){
              product.handle = attribute.values[0].value[0]
            }

            if(attribute.id === "product_value_tags_front_end_tags"){
              if(window.wizzyConfig.common.collectionHandle === "buy-3-at-1249"){
                if(attribute?.values[1]?.value[0] === "buy3@1249"){
                  product.buyAtHigh = true;
                }
                if(attribute?.values[0]?.value[0] === "buy3@1199"){
                  product.buyAtLow = true;
                }
              }
            }

        })
          
        if(product.price){ 
            product.price = parseInt(product.price.replace(/,/g, ''),10)
        }
          
        if(product.sellingPrice){
            product.sellingPrice = parseInt(product.sellingPrice.replace(/,/g, ''),10)
        }

        product.swatches.forEach((swatch)=>{
          if(swatch.key === "sizes"){
            swatch.values =  swatch.values.sort((a, b) => parseInt(a.value) - parseInt(b.value));
          }
        })

          
          
      })
      // console.log("Product", payload);
      return payload;
    }) 
  },

  
  registerWizzyEvent: function(eventname,callback){
    window.wizzyConfig.events.registerEvent(wizzyConfig.events.allowedEvents[eventname],function(payload){
      let updatedPayload;
      try{
        updatedPayload = callback(payload);
      }catch(e){
        // console.log(eventname,e)
      }
      finally{
          return updatedPayload ? updatedPayload : payload;
      }
    })
  },

  replaceTemplate: function(div){
    let newDiv = document.getElementById(div+"-new").text;
    let oldDiv = document.getElementById(div)
    oldDiv.text = newDiv;
  },

  replaceAllTemplate: function(){
    this.replaceTemplate("wizzy-search-results-product");
    this.replaceTemplate("wizzy-search-results");
    this.replaceTemplate("wizzy-search-wrapper");
    //if(!this.isMobile)
    this.replaceTemplate("wizzy-autocomplete-topproducts")
    this.replaceTemplate("wizzy-search-empty-results");
    // this.replaceTemplate("wizzy-common-select")
    // if(this.isMobile) this.replaceTemplate("wizzy-search-summary")
  },

  allEventsRegister: function(){
    this.beforeInit();
    this.afterProductsTransformed()
    this.productsResultsRendered();
    this.beforeRenderResults()
    this.beforeAutocompleteExecuted();
    this.beforeAutocompleteRender();
    this.beforeSearchExecuted();
    this.beforeFilterExecuted();
    this.viewRendered();
   // this.productsCachedResultsRendered();
  },

  wizzyFetch :function(url, callback){
    fetch(url).then((response)=>{
      if(response.status !== 200)  throw new Error('Network response was not ok')
      return response.text()
    }).then((data)=>{callback(data)}).catch((e)=>{console.log(e)})
  },

   sizeSorting : function(sizes) {
   
    let temp = ['100ml', '140gm', '145gm', '175ml', '235gm', '245gm', '250ml', '335ml', '340ml', '400ml', '650ml', '800ml', '1000ml']


   return sizes.sort((a,b)=> {
     if(temp.indexOf(b['key']) === -1) return 1
     if(temp.indexOf(a['key']) === -1) return 1
     if(temp.indexOf(b['key']) > temp.indexOf(a['key']) ) return -1
     else return 0
   })
}
  
  
}


async function clickSiblings() {
  // Select all elements with class "swatch-selected" and title "650ml"
  const elements = $(".swatch-selected[title='650ml']");

  // Use a loop to click on siblings one by one
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    // console.log("Processing element:", $(element));

    // Find the sibling with title "340ml"
    const sibling340ml = $(element).siblings("[title='340ml']");

    if (sibling340ml.length > 0) {
      // console.log("Clicking on sibling:", sibling340ml);

      // Wrap the click operation in a Promise
      await new Promise((resolve) => {
        sibling340ml.click();

        // Assuming there's some asynchronous operation (e.g., API call)
        // Adjust the timeout value based on the actual delay
        setTimeout(resolve, 200); // Wait for 2 seconds (adjust as needed)
      });

      // console.log("Sibling click completed.");
    } else {
      // console.log("No sibling with title '340ml' found.");
    }
  }
}